export var WeekDaysEnum;
(function (WeekDaysEnum) {
    WeekDaysEnum["SUNDAY"] = "Sunday";
    WeekDaysEnum["MONDAY"] = "Monday";
    WeekDaysEnum["TUESDAY"] = "Tuesday";
    WeekDaysEnum["WEDNESDAY"] = "Wednesday";
    WeekDaysEnum["THURSDAY"] = "Thursday";
    WeekDaysEnum["FRIDAY"] = "Friday";
    WeekDaysEnum["SATURDAY"] = "Saturday";
})(WeekDaysEnum || (WeekDaysEnum = {}));
//# sourceMappingURL=WeekDaysEnum.js.map